import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

//User reducers
import features from './features';
import isTeamAdmin from './isTeamAdmin';
import selectedTeamMembers from './selectedTeamMembers';
import user from './user';
import updateUserPasswordFailed from './updateUserPasswordFailed';
import isLoggedOut from './isLoggedOut';

//Event reducers
import event from './event';
import isEventLoading from './isEventLoading';
import eventEligibleMembers from './eventEligibleMembers';
import eventCrew from './eventCrew';
import userEvents from './userEvents';
import teamEvents from './teamEvents';
import archivedEvents from './archivedEvents';
import pastTeamEvents from './pastTeamEvents';
import teamEventSearchResults from './teamEventSearchResults';
import userEventSearchResults from './userEventSearchResults';
import editingEvent from './editingEvent';
import creatingEvent from './creatingEvent';
import duplicatingEvent from './duplicatingEvent';
import eventUploadStatusVisibility from './eventUploadStatusVisibility';

//File system object reducers
import eventFSObjects from './eventFSObjects';
import isFSObjectLoading from './isFSObjectLoading';
import eventFSObjectsSorting from './eventFSObjectsSorting';
import archivedEventFSObjects from './archivedEventFSObjects';
import selectedEventFSFolder from './selectedEventFSFolder';
import multiSelectedFSObjects from './multiSelectedFSObjects';
import eventFSObjectSearchResults from './eventFSObjectSearchResults';
import eventFSObjectUploadStatuses from './eventFSObjectUploadStatuses';
import eventArchivedFSObjectSearchResults from './eventArchivedFSObjectSearchResults';
import archivedEventFSObjectsSorting from './archivedEventFSObjectsSorting';

//Tags reducers
import tags from './tags';

//Team reducers
import teams from './teams';
import team from './team';
import teamEligibleMembers from './teamEligibleMembers';
import activeUsers from './activeUsers';
import assignedEventTools from './assignedEventTools';

//Modal reducer
import modal from './modal';

// Notification reducer
import notification from './notification';

//Routing reducers
import backToUserDash from './backToUserDash';

export default history =>
  combineReducers({
    router: connectRouter(history),
    modal,
    notification,
    features,
    isTeamAdmin,
    selectedTeamMembers,
    user,
    updateUserPasswordFailed,
    tags,
    event,
    eventCrew,
    eventEligibleMembers,
    team,
    teamEligibleMembers,
    teams,
    userEvents,
    teamEvents,
    archivedEvents,
    pastTeamEvents,
    teamEventSearchResults,
    userEventSearchResults,
    editingEvent,
    creatingEvent,
    duplicatingEvent,
    eventFSObjects,
    isEventLoading,
    isFSObjectLoading,
    archivedEventFSObjects,
    eventFSObjectsSorting,
    selectedEventFSFolder,
    multiSelectedFSObjects,
    eventFSObjectSearchResults,
    eventArchivedFSObjectSearchResults,
    eventUploadStatusVisibility,
    eventFSObjectUploadStatuses,
    backToUserDash,
    isLoggedOut,
    activeUsers,
    assignedEventTools,
    archivedEventFSObjectsSorting
  });
